import { countText, formatReminderEuros } from './invoiceRemindersText';

const SummaryCard = ({ label, value }) => (
  <div className="flex-1 min-w-[200px] rounded-lg border border-gray-200 bg-white px-4 py-3">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="mt-1 text-xl font-medium text-gray-900">{value}</div>
  </div>
);

/**
 * The three cards above the reminders (JBWEB-1283, mockup 7.1): "À faire"
 * (invoices), "En retard" (what they owe) and "Contentieux" (count and
 * amount). A dash until the summary is read.
 */
const RemindersSummaryCards = ({ summary, text }) => {
  const unknown = text('cards.unknown');
  const litigation = summary?.litigation;

  return (
    <div className="flex flex-wrap gap-3" data-testid="reminders-summary">
      <SummaryCard
        label={text('cards.toDo')}
        value={
          summary
            ? countText(text, 'cards.invoices', summary.toDo ?? 0)
            : unknown
        }
      />
      <SummaryCard
        label={text('cards.late')}
        value={summary ? formatReminderEuros(summary.lateAmount) : unknown}
      />
      <SummaryCard
        label={text('cards.litigation')}
        value={
          litigation
            ? text('cards.litigationValue', {
                count: litigation.count ?? 0,
                amount: formatReminderEuros(litigation.amount),
              })
            : unknown
        }
      />
    </div>
  );
};

export default RemindersSummaryCards;
